import { Box, makeStyles } from '@material-ui/core';
import React from 'react';

import HeaderContainer from '../modules/Header/HeaderContainer';
import FooterContainer from '../modules/Footer/FooterContainer';

const useStyles = makeStyles((theme) => ({
  childContainer:{
    marginTop:theme.spacing(8),
    transition:"margin 225ms",
  },
  childContainerOpen:{
    marginLeft:theme.spacing(35),
  },
  childContainerClose:{
    marginLeft:0,
  }
}));

const Layout = ({ children }) => {
  const classes = useStyles();

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const checkDrawerOpen=(val)=>{
    setDrawerOpen(val);
  }

  return (
    <>
      <HeaderContainer checkDrawerOpen={checkDrawerOpen} />
      <Box component="div" className={`${classes.childContainer} ${drawerOpen?classes.childContainerOpen:classes.childContainerClose}`}>
        {children}
      </Box>
      <FooterContainer />
    </>
  );
};

export default Layout;
